import { render, staticRenderFns, recyclableRender, components } from "./mask.vue?vue&type=template&id=933795a8&scoped=true&"
var renderjs
import script from "./mask.vue?vue&type=script&lang=js&"
export * from "./mask.vue?vue&type=script&lang=js&"
import style0 from "./mask.vue?vue&type=style&index=0&id=933795a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933795a8",
  null,
  false,
  components,
  renderjs
)

export default component.exports